function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1z",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 15h2M16 12h2M16 9h2",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.35 14.24a1 1 0 001.3 1.52l-1.3-1.52zm8.3-4.48a1 1 0 00-1.3-1.52l1.3 1.52zm-1.3 6a1 1 0 001.3-1.52l-1.3 1.52zm-5.7-7.52a1 1 0 00-1.3 1.52l1.3-1.52zm0 7.52l7-6-1.3-1.52-7 6 1.3 1.52zm7-1.52l-7-6-1.3 1.52 7 6 1.3-1.52z",
  fill: "#fff"
});
function SvgNoShowWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}
export default SvgNoShowWhite;